import { BUY_PICKUP_SUCCESS, BUY_PICKUP_REQUEST, BUY_PICKUP_FAILURE, BUY_PICKUP_REST } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const buyPickupReducer = (state = initialState, action) => {
    switch (action.type) {
        case BUY_PICKUP_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case BUY_PICKUP_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case BUY_PICKUP_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case BUY_PICKUP_REST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        default:
            return state;
    }
};
export default buyPickupReducer;
